<template>
    <div
        @click="focusPage"
        @dblclick="quickPreview(src)"
        @contextmenu.prevent.stop="showPreviewContextMenu($event)"
        v-visible.once="drawPage"
        :class="{ focused: isPageFocused && !isPageOrderable}"
        class="pdf-thumbnail"
        :data-index="index"
    >
        <div class="thumbnail-container" :class="{'w-100': isPageOrderable}">
            <img
                v-if="src"
                :src="src"
                class="box-shadow"
                v-bind:style="{ transform: 'rotate(' + rotation + 'deg)', transition: '0.' + rotating_speed + 's ease-in-out transform' }"
            />
            <div
                v-else
                class="placeholder box-shadow"
            >
                <div class="content">
                    Loading
                </div>
            </div>
            <span class="page-number" v-if="!isPageOrderable">{{ page.pageNumber }}</span>
            <span class="has-signature-blocks" v-if="signatureCount > 0 && !merge">
        {{ signatureCount }} {{ 'signature' | pluralize(signatureCount) }}
      </span>
            <span class="has-signature-blocks" v-if="suggestedSignatures > 0 && merge && showSuggestions">
        {{ suggestedSignatures }} {{ 'suggested signature' | pluralize(suggestedSignatures) }}
      </span>
            <button class="pdf-toolbox" v-if="isPageOrderable" v-b-tooltip.hover title="Remove Page"
                    @click="removePage(index)">
                <font-awesome-icon :icon="['fas', 'times-circle']"/>
            </button>
        </div>
        <div class="page-functions">
            <button class="pdf-rotate" v-if="isPageOrderable" v-b-tooltip.hover title="Rotate Page Left"
                    @click="rotatePageLeft(page)">
                <font-awesome-icon :icon="['fas', 'undo']"/>
            </button>
            <button class="pdf-rotate" v-if="isPageOrderable" v-b-tooltip.hover title="Rotate Page Right"
                    @click="rotatePageRight(page)">
                <font-awesome-icon :icon="['fas', 'redo']"/>
            </button>
        </div>
        <context-menu-reorder v-if="isPageOrderable" v-bind="{pageNumber}"></context-menu-reorder>
    </div>
</template>

<script>

import visible from './directives/visible';
import ContextMenuReorder from './PDFContextMenuReorder';

export default {
    name: 'PDFThumbnail',
    components: {
        ContextMenuReorder,
    },
    props: {
        page: {
            type: Object,
            required: true,
        },
        pdfid: {
            required: false,
        },
        scale: {
            required: true,
        },
        isPageFocused: {
            type: Boolean,
            default: false,
        },
        signatures: {
            type: Array
        },
        merge: {
            type: Boolean
        },
        showSuggestions: {
            type: Boolean
        },
        isPageOrderable: {
            type: Boolean,
            default: false
        },
        index: {
            required: false
        }
    },

    directives: {
        visible
    },

    data() {
        return {
            src: undefined,
            signatureSuggestedPage: [],
            clickedArea: '',
            rotation: 0,
            rotating_speed: 2
        };
    },

    computed: {
        viewport() {
            return this.page.getViewport(1.0);
        },

        pageNumber() {
            return `${this.page.pageNumber}${this.pdfid}`;
        },

        signatureCount() {
            return this.signatures.filter(item => item.page_num == this.page.pageNumber).length;
        },

        suggestedSignatures() {
            return this.signatureSuggestedPage.length
        }
    },

    methods: {
        focusPage() {
            this.$bus.$emit('pdf::page::visibility::focus', this.pageNumber);
        },

        showPreviewContextMenu(e) {
            if (!this.isPageOrderable) return;
            this.$bus.$emit("pdf::contextmenu::clickedarea", e);
            this.$bus.$emit("pdf::contextmenu::menuopen");
            let menu = document.getElementById("pdf-context-menu-" + this.pageNumber);
            let rect = e.target.getBoundingClientRect();
            menu.style.left = Math.floor(e.clientX - rect.left) + 'px'
            menu.style.top = Math.floor(e.clientY - rect.top) + 'px'
            menu.style.display = 'block'
        },

        drawPage(restoring = false) {
            if (this.renderTask) return;

            const {viewport} = this;
            const canvas = document.createElement('canvas')
            const canvasContext = canvas.getContext('2d')
            const renderContext = {canvasContext, viewport};
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            this.renderTask = this.page.render(renderContext);

            this.renderTask
                .then(() => {
                    this.src = canvas.toDataURL();
                    canvas.width = 0;
                    canvas.height = 0;
                }).then(() => {
                return this.page.getTextContent();
            }).then((textContent) => {
                textContent.items.forEach(span => {
                    const regex = new RegExp('signature', 'i');
                    let match = regex.test(span.str);
                    if (!match) return
                    this.signatureSuggestedPage.push(this.pageNumber);
                });
            }).then(() => {
                this.$bus.$emit('pdf::thumbnail::rendered', {
                    page: this.page,
                    text: `Rendered thumbnail ${this.pageNumber}`,
                });
            })
                .catch(response => {
                    this.destroyRenderTask();
                });
        },

        quickPreview(src) {
            this.$bus.$emit('pdf::page::quickpreview', src);
        },

        removePage(index) {
            this.$bus.$emit('pdf::page::remove', index);
        },

        destroyPage(_newPage, page) {
            // if (page) page._destroy();
            // this.destroyRenderTask();
        },

        destroyRenderTask() {
            if (!this.renderTask) return;
            this.renderTask.cancel();
            this.renderTask = false;
        },

        restorePage(page) {
            if (page != this.page) return;
            this.renderTask = false;
            this.drawPage(true);

        },

        rotatePageRight(page) {
            page._pageInfo.rotate = page._pageInfo.rotate == 270 ? 0 : page._pageInfo.rotate + 90;
            this.rotation = 90;
            setTimeout(() => {
                this.renderTask = false;
                this.drawPage(true);
                this.rotating_speed = 0;
                this.rotation = 0;
            }, 200);
            this.rotating_speed = 2;
            this.$bus.$emit('pdf::pages::filtered', true)
        },
        rotatePageLeft(page) {
            page._pageInfo.rotate = page._pageInfo.rotate == 0 ? 270 : page._pageInfo.rotate - 90;
            this.rotation = -90;
            setTimeout(() => {
                this.renderTask = false;
                this.drawPage(true);
                this.rotating_speed = 0;
                this.rotation = 0;
            }, 200);
            this.rotating_speed = 2;
            this.$bus.$emit('pdf::pages::filtered', true)
        },

        updateVisibility() {
            this.$bus.$emit('pdf::page::visibility::update');
        },
    },

    watch: {
        page: 'destroyPage',
        src: 'updateVisibility',
        scale: 'updateVisibility'
    },

    created() {
        this.$bus.$on('pdf::page::restore', this.restorePage);
    },

    beforeDestroy() {
        this.destroyPage(undefined, this.page);
        // this.$bus.$off("pdf::page::restore");
    },
}
</script>

<style lang="scss" scoped>
.pdf-thumbnail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100% - 5px);
    margin: 2.5px 0;
    font-size: 12px;
    text-align: center;
    cursor: pointer;

    .thumbnail-container {
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin: 13px 10px 5px;
        width: 70%;
        padding: 1rem;
        height: 100%;
    }


}

img,
.placeholder {
    border: 1px solid #bfbfbf;
    border-radius: 0px;
    width: 100%;

}

.pdf-thumbnail {
    &:hover {
        .thumbnail-container {
            background: #e6e6e6;;
        }
    }

    &.focused {
        .thumbnail-container {
            background: #d3d3d3;
        }
    }
}

.placeholder {
    background: white;
    background-clip: content-box;
    position: relative;
}

.placeholder:before {
    content: '';
    display: block;
    padding-top: 75%;
}

.placeholder .content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.has-signature-blocks {
    position: absolute;
    top: 5px;
    width: auto;
    background: #f8a42c;
    color: #000;
    text-align: center;
    padding: 0rem 0.8rem;
    letter-spacing: 1px;
}

.page-functions {
    button {
        border: 1px solid #d3d3d3;
        padding: 2px 7px;
        border-radius: 4px;
        color: #777777;
    }
}

.page-number {
    color: #000;
}
</style>
